<template>
  <router-view />
</template>

<script>
export default {
  name: "FarmProductivityIndex",
};
</script>
